export default "__VITE_ASSET__566735bc__"